import DonationIcon from "@mui/icons-material/EuroSymbol";
import DonationList from "./DonationList";
import DonationEdit from "./DonationEdit";
import DonationCreate from "./DonationCreate";
import DonationShow from "./DonationShow";

const DonationResourceProps = {
	name: "donation",
	list: DonationList,
	edit: DonationEdit,
	show: DonationShow,
	create: DonationCreate,
};

export const DonationMenuProps = {
	to: "/donation",
	primaryText: "Dons",
	icon: DonationIcon,
};

export default DonationResourceProps;
